import React from 'react'
import { IProps } from './index'
import { Text } from '../../elements/Text'
import { getColorTheme, LegacyColor } from 'marketing-site/src/library/utils'
import { CTAOrVariationContainer } from 'marketing-site/src/transformers/CTA'
import { FooterWithCTA as FooterWithCTADefault } from './component'
import { NewBrandingHoc } from '../../utils/NewBrandingHoc'

const FooterWithCTALegacy: React.FC<IProps> = ({ text, bgColor, cta }) => {
  const theme = getColorTheme('legacy', bgColor || LegacyColor.White)

  return (
    <>
      <div className="footer-with-cta">
        <Text size="body">{text} </Text>
        <span>
          <CTAOrVariationContainer {...cta} />
        </span>
      </div>
      <style jsx>
        {`
          .footer-with-cta {
            display: flex;
            width: 100%;
            padding: 24px 0;
            flex-wrap: wrap;
            text-align: center;
            justify-content: center;
            align-items: baseline;
            gap: 3.25rem;
            position: fixed;
            bottom: 0;
            z-index: 1;
            background-color: ${bgColor ? theme.backgroundColor : 'transparent'};
            color: ${theme.textColor};
          }
          :global(.footer-with-cta > span:first-child) {
            font-size: 1.375rem;
          }
        `}
      </style>
    </>
  )
}

export const FooterWithCTA = NewBrandingHoc(FooterWithCTALegacy, FooterWithCTADefault)
